"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DependencyFieldValueGetter = void 0;
const safe_field_value_1 = require("../../safe-field-value");
const arrays_1 = require("../../type-checking/arrays");
const objects_1 = require("../../type-checking/objects");
const typing_1 = require("../../type-checking/typing");
const get_value_1 = require("./get-value");
class DependencyFieldValueGetter extends safe_field_value_1.BaseFieldValueGetter {
    constructor() {
        super(...arguments);
        this.isValidFieldValue = (fieldValue) => {
            return (0, objects_1.isValidObjectValue)(fieldValue, {
                predecessor: (0, typing_1.Optional)(arrays_1.isArrayOfObjectsValue),
                successor: (0, typing_1.Optional)(arrays_1.isArrayOfObjectsValue),
            });
        };
        this.getEmptyValue = () => (0, get_value_1.getDependencyFieldEmptyValue)();
    }
}
exports.DependencyFieldValueGetter = DependencyFieldValueGetter;
